import React from "react";
import { useNavigate } from "react-router-dom";
import { contextapi } from "../../helpers/contextapi";
import { axiospost } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import ErrorMessage from "../../components/ErrorMessage";
import { ms_applicant } from "@v2/validators";
import GoogleSignIn from "./GoogleSignIn";

const Login = () => {
  const context = React.useContext(contextapi);
  const navigate = useNavigate();
  const [singleLogin, setSingleLogin] = React.useState(null);

  React.useEffect(() => {
    localStorage.clear();
    context.setvalues({ ...context.values, main_menu: undefined });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (singleLogin !== null) {
      // console.log(singleLogin)
      localStorage.setItem("isApplicant", singleLogin.token);
      localStorage.setItem("isApplicantData", JSON.stringify(singleLogin.user));
      context.setvalues({ ...context.values, user: singleLogin.user });
      swal("success", "Your login was successful");
      navigate("/app/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleLogin]);


  const _login = async (values) => {
    try {
      const emailaddress = values.emailaddress;
      const password = values.password;
      const req = await axiospost("ms_applicant/login", {
        emailaddress,
        password,
      });
      if (req.status !== 200) {
        throw new Error(req?.message);
      }
      const { data } = req;
      if (data.token) {
        const { user, token, verify } = data;
        if (!verify) {
          swal("success", "Your login is successful, but your account is not verified");
          navigate("/verify")
          return;
        }
        localStorage.setItem("isApplicant", token);
        localStorage.setItem("isApplicantData", JSON.stringify(user));
        context.setvalues({ ...context.values, user: user });
        swal("success", "Your login is successful");
        navigate("/app/dashboard");
      } else {
        throw new Error(data.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-7 mx-auto">
              <div className="auth-form-light text-left py-3 px-4 px-sm-5">
                <div className="brand-logo text-center">
                  <img src="images/logo.png" alt="logo" />
                </div>
                <div className="text-center my-5 mt-5">
                  <h4 className="text-uppercase">Kebbi State Polytechnic Dakingari</h4>
                  <h6 className="font-weight-light">ADMISSION APPLICATION PORTAL</h6>
                  <h6 className="font-weight-light text-uppercase">Sign in to continue</h6>
                </div>
                <Formik
                  initialValues={{ emailaddress: "", password: "" }}
                  validationSchema={ms_applicant.applicantloginrule}
                  initialTouched={{ zip: true }}
                  onSubmit={_login}
                >
                  {({ isSubmitting, touched, errors }) => (
                    <Form className="my-4">
                      <ErrorMessage
                        name={"emailaddress"}
                        label="Email Address"
                        type="email"
                        errors={errors?.emailaddress}
                        touched={touched?.emailaddress}
                      />

                      <ErrorMessage name={"password"} label="Password" type="password" errors={errors?.password} touched={touched?.password} />
                      <div className="mt-3">
                        <button disabled={isSubmitting} type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                          {isSubmitting ? "Please wait..." : "Login to Account"}
                        </button>
                      </div>
                      <div style={{ marginTop: 10 }} className="my-2 mt-5 d-flex justify-content-between align-items-end">
                        <Link to="/account" className="auth-link text-black">
                          Create Account?
                        </Link>
                        <GoogleSignIn setLogin={setSingleLogin} />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
